// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"MenuTitle_ComponentHolder__1vQuU"};